import { useContext } from 'react';
import ResultContext from './ResultContext';

const useResultContext = () => useContext(ResultContext);

export default useResultContext;
